// extracted by mini-css-extract-plugin
export default {"cls1":"u44mHsmh7Z11ABs1Rq8q","cls2":"UjJYl6zMnfBjVK3EH7wO u44mHsmh7Z11ABs1Rq8q"};